import { getCurrentInstance, onMounted, ref } from 'vue';
import popupUtil from '@/commons/popupUtil';
import { ModuleAccountCombo } from '@/stores/moduleConst';

export const useSelectRefNoInvoice = () => {
  const { proxy } = getCurrentInstance();
  // Kiểm tra xem tk 331 có chi tiết theo đối tượng không
  const isViewInvoce = ref(true);
  onMounted(() => {
    isViewInvoce.value = proxy.$store.getters[`${ModuleAccountCombo}/items`].find(
      x => x.account_number == '331'
    )?.is_detail_by_accounting_object;
  });

  const showRefNoInvoice = () => {
    popupUtil.show('SelectRefNoInvoicePopup', {
      accountingObjectID: proxy.model?.accounting_object_id, // id tài khoản nhận
      selectedList: proxy.gridDetail.data.filter(x => x.state != 4 && x.state != 3),
      options: {
        // list - dữ liệu nhận về
        submit: list => {
          selectRefNoInvoice(list);
        },
      },
    });
  };

  /**
   * Sự kiện bind dư liệu vào form detail
   * lttuan1 - 9.2.2023
   */
  const selectRefNoInvoice = list => {
    const me = proxy;
    // Danh sách chứng từ đã có ở detail
    // Nếu có chứng từ này rồi thì xóa đi thêm cái mới nhát:
    var deleteList = proxy.$ms.commonFn.innerJoin(
      proxy.gridDetail.dataView,
      list,
      l => ({ org_ref_no: l.org_ref_no, debit_account: l.debit_account }),
      l => ({ org_ref_no: l.org_ref_no, debit_account: l.debit_account }),
      l => l
    );
    // Xóa dòng trùng
    if (deleteList.length > 0) {
      deleteList.forEach(el => {
        me.gridDetail.deleteRow(el);
      });
    }
    // index bắt đầu thêm
    var i = me.gridDetail.dataView.findLastIndex(x => x.state != 4) + 1;
    // Thêm dòng đã chọn
    list.forEach((item, index) => {
      // Nếu không có dòng thì thêm
      if (!me.gridDetail.dataView[i + index]) {
        me.gridDetail.addRow();
        // Nếu có tab thuế thì cũng phải cộng dòng
        if(me.gridDetailOther){
          me.gridDetailOther.addRow();
        }
      }
      // Gán dữ liệu
      me.bindDefaultData(me.gridDetail, me, i + index);
      
      if (me.refType == proxy.$ms.constant.RefType.GLGeneralVoucher) {
        me.gridDetail.dataView[i + index].debit_accounting_object_code = item?.accounting_object_code;
        me.gridDetail.dataView[i + index].debit_accounting_object_id = item?.accounting_object_id;
        me.gridDetail.dataView[i + index].credit_accounting_object_code = item?.accounting_object_code;
        me.gridDetail.dataView[i + index].credit_accounting_object_id = item?.accounting_object_id;
      } else {
        me.gridDetail.dataView[i + index].accounting_object_id = item?.accounting_object_id;
        me.gridDetail.dataView[i + index].accounting_object_code = item?.accounting_object_code;
      }
      me.gridDetail.dataView[i + index].debit_account = item?.debit_account;
      me.gridDetail.dataView[i + index].org_ref_date = item?.org_ref_date;
      me.gridDetail.dataView[i + index].org_ref_no = item?.org_ref_no;
      me.gridDetail.dataView[i + index].inv_no = item?.inv_no;
      me.gridDetail.dataView[i + index].inv_date = item?.inv_date;
      me.gridDetail.dataView[i + index].inv_series = item?.inv_series;
      me.gridDetail.dataView[i + index].amount = item?.compare;
      me.gridDetail.dataView[i + index].amount_oc = item?.compare;
      me.gridDetail.dataView[i + index].state = 1;
      if(me.gridDetailOther){
        me.bindDefaultData(me.gridDetailOther, me, i + index);
        me.gridDetailOther.dataView[i + index].inv_no = item?.inv_no;
        me.gridDetailOther.dataView[i + index].inv_date = item?.inv_date;
        me.gridDetailOther.dataView[i + index].inv_series = item?.inv_series;
        // me.gridDetailOther.dataView[i + index].state = 1;
      }
    });
  };

  return { showRefNoInvoice, isViewInvoce };
};
